<div class="dashboard-header">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h5 class="dashboard-title mb-0">Dashboard</h5>
    </div>
    <div class="header-actions">
      <button *ngIf="fromAnalysisManager" class="icon-btn" (click)="back()" title="Back to Analysis Manager">
        <i class="fa fa-arrow-left"></i>
      </button>
      <button class="icon-btn" (click)="refreshPage()" title="Refresh dashboard data">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>
</div>

<!-- Stage Tabs -->
<div class="stage-tabs-bar">
  <ul class="nav nav-tabs tab-nav" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link"
        [class.active]="activeTab === 1"
        (click)="setActiveTab(1)">
        <i class="fa fa-dollar-sign tab-icon tab-icon-costing"></i>
        <span>Costing</span>
        <span class="tab-badge tab-badge-costing">{{ costingTotalCount || costingData.length }}</span>
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link"
        [class.active]="activeTab === 2"
        (click)="setActiveTab(2)">
        <i class="fa fa-shopping-cart tab-icon tab-icon-procurement"></i>
        <span>Procurement</span>
        <span class="tab-badge tab-badge-procurement">{{ procurementTotalCount || procurementData.length }}</span>
      </button>
    </li>
  </ul>
</div>

<!-- Filter Bar -->
<div class="filter-bar">
  <div class="filter-bar-left">

    <div class="filter-item position-relative" title="Project Name" style="width: 160px;">
      <input id="projectName" class="filter-input" type="text"
        placeholder="Search Project" [(ngModel)]="selectedProjectName" (input)="filterProjectNames()"
        (focus)="onProjectFocus()" (blur)="hideDropdown()" (keyup.enter)="onProjectEnter()" autocomplete="off" />

      <ul class="list-group position-absolute project-dropdown"
        *ngIf="showProjectDropdown && filteredProjectNames.length > 0">
        <li class="list-group-item list-group-item-action project-dropdown-item"
          *ngFor="let name of filteredProjectNames" (mousedown)="selectProjectName(name)" [title]="name">
          {{ name }}
        </li>
      </ul>
    </div>

    <div class="filter-item" title="Select Customer">
      <select id="customerName" class="filter-select" aria-label="Select Customer Name"
        [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
        <option value="">Customer</option>
        <option *ngFor="let cus of allCustomerDetails" [value]="cus.customerName">{{ cus.customerName }}</option>
      </select>
    </div>
    <div class="filter-item" title="Select Engineer">
      <select id="enginner" class="filter-select" aria-label="Select Engineer Name"
        [(ngModel)]="selectedEngineer" (change)="onSelectEnginner()">
        <option disabled value="" [selected]="selectedEngineer === ''">Engineer</option>
        <option *ngFor="let cus of engineersData" [value]="cus.engineer_id">{{ cus.engineer_name }}</option>
      </select>
    </div>
    <div class="filter-item" title="Select Stage">
      <select id="stageFilter" class="filter-select" aria-label="Select Stage"
        [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
        <option disabled value="" [selected]="selectedCurrentStage === ''">Stage</option>
        <option value="Costing">Costing</option>
        <option value="Procurement">Procurement</option>
      </select>
    </div>

    <button type="button" class="filter-btn filter-btn-ecd"
      [class.active]="!!(fromExpectedCompletionDate || toExpectedCompletionDate)"
      (click)="openModalECD()">
      <i class="fa fa-calendar"></i> ECD
    </button>

      <!-- ECD Modal Popup -->
      <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
        [ngStyle]="{'display': showModalECD ? 'block' : 'none'}" (click)="closeModalECD()">
        <div class="modal-dialog date-filter-dialog-top" role="document" (click)="$event.stopPropagation()">
          <div class="modal-content date-filter-modal">
            <div class="date-filter-header">
              <div class="date-filter-header-left">
                <div class="date-filter-icon date-filter-icon-ecd">
                  <i class="fa fa-calendar"></i>
                </div>
                <div>
                  <div class="date-filter-title">Expected Completion Date</div>
                  <div class="date-filter-subtitle">Filter projects by completion date range</div>
                </div>
              </div>
              <button type="button" class="date-filter-close" (click)="closeModalECD()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="date-filter-body">
              <div class="date-filter-fields">
                <div class="date-filter-field">
                  <label for="fromExpectedCompletionDate" class="date-filter-label">
                    <i class="fa fa-arrow-right"></i> From
                  </label>
                  <input id="fromExpectedCompletionDate" class="date-filter-input" type="date"
                    aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
                <div class="date-filter-field">
                  <label for="toExpectedCompletionDate" class="date-filter-label">
                    <i class="fa fa-arrow-left"></i> To
                  </label>
                  <input id="toExpectedCompletionDate" class="date-filter-input" type="date"
                    aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
              </div>
            </div>
            <div class="date-filter-footer">
              <button type="button" class="date-filter-btn-reset" (click)="resetDates()">
                <i class="fa fa-undo"></i> Reset
              </button>
              <button type="button" class="date-filter-btn-apply" (click)="closeModalECD()">
                <i class="fa fa-check"></i> Apply
              </button>
              <button type="button" class="date-filter-btn-close" (click)="closeModalECD()">
                <i class="fa fa-times"></i> Close
              </button>
            </div>
          </div>
        </div>
      </div>
    <button type="button" class="filter-btn filter-btn-rfq"
      [class.active]="!!(fromRfqDate || toRfqDate)"
      (click)="openModalRFQ()">
      <i class="fa fa-calendar"></i> RFQ
    </button>

      <!-- RFQ Date Range Modal Popup -->
      <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
        [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}" (click)="closeModalRFQ()">
        <div class="modal-dialog date-filter-dialog-top" role="document" (click)="$event.stopPropagation()">
          <div class="modal-content date-filter-modal">
            <div class="date-filter-header">
              <div class="date-filter-header-left">
                <div class="date-filter-icon date-filter-icon-rfq">
                  <i class="fa fa-calendar"></i>
                </div>
                <div>
                  <div class="date-filter-title">RFQ Date</div>
                  <div class="date-filter-subtitle">Filter projects by RFQ date range</div>
                </div>
              </div>
              <button type="button" class="date-filter-close" (click)="closeModalRFQ()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="date-filter-body">
              <div class="date-filter-fields">
                <div class="date-filter-field">
                  <label for="fromRfqDate" class="date-filter-label">
                    <i class="fa fa-arrow-right"></i> From
                  </label>
                  <input id="fromRfqDate" class="date-filter-input" type="date" aria-label="Select From RFQ Date"
                    [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
                </div>
                <div class="date-filter-field">
                  <label for="toRfqDate" class="date-filter-label">
                    <i class="fa fa-arrow-left"></i> To
                  </label>
                  <input id="toRfqDate" class="date-filter-input" type="date" aria-label="Select To RFQ Date"
                    [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
                </div>
              </div>
            </div>
            <div class="date-filter-footer">
              <button type="button" class="date-filter-btn-reset" (click)="resetRfqDates()">
                <i class="fa fa-undo"></i> Reset
              </button>
              <button type="button" class="date-filter-btn-apply" (click)="closeModalRFQ()">
                <i class="fa fa-check"></i> Apply
              </button>
              <button type="button" class="date-filter-btn-close" (click)="closeModalRFQ()">
                <i class="fa fa-times"></i> Close
              </button>
            </div>
          </div>
        </div>
      </div>

    <button type="button" class="filter-btn filter-btn-reset" title="Reset fields" (click)="resetFields()">
      <i class="fa fa-undo"></i> Reset
    </button>
  </div>
  <div class="filter-bar-right">
    <button type="button" class="action-btn" title="Create New Project"
      (click)="openProjectModel(projectModal, null, null)">
      <i class="fa fa-plus"></i> Add Project
    </button>
    <button type="button" class="action-btn action-btn-secondary" title="Create New Customer"
      (click)="openCustomerModel(customerModal)">
      <i class="fa fa-user-plus"></i> Add Customer
    </button>
  </div>
</div>

  <!-- <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">
      <div class="form-group card" (click)="onOpenClickedProject('Open')">
        <div class="custom-card-small custom-card-open-projects">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{openStatusCount}}</div>
            <div class="custom-card-text-small">Open Projects</div>
          </div>
        </div>
      </div>
      <div class="form-group card" (click)="onOverdueClick()">
        <div class="custom-card-small custom-card-overdue">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{overdueCount}}</div>
            <div class="custom-card-text-small">Over Due</div>
          </div>
        </div>
      </div>
      <div class="form-group card" (click)="onThisMonthClick()">
        <div class="custom-card-small custom-card-yet-to-approved">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{ thisMonthProjects?.length || 0 }}</div>
            <div class="custom-card-text-small">This Month</div>
          </div>
        </div>
      </div>
      <div class="form-group card">
        <div class="custom-card-small custom-card-high-risk-parts">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">10</div>
            <div class="custom-card-text-small">High Risk Parts</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

<!-- Stat Cards -->
<div class="stat-cards-row">
  <div class="stat-card stat-card-open" (click)="onOpenClickedProject('Open')">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{openStatusCount}}</div>
        <div class="stat-card-label">Open Projects</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-folder-open"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-overdue" (click)="onOverdueClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{overdueCount}}</div>
        <div class="stat-card-label">Over Due</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-clock"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-month" (click)="onThisMonthClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{ thisMonthProjects?.length || 0 }}</div>
        <div class="stat-card-label">This Month</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-calendar"></i>
      </div>
    </div>
  </div>

  <!-- <div class="stat-card stat-card-risk">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">10</div>
        <div class="stat-card-label">High Risk Parts</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
    </div>
  </div> -->
</div>

<div *ngIf="loading" class="sb-in-progress-card my-4" style="background: #ffffff; border: 1px dashed #cbd5e1; border-radius: 16px; padding: 36px 20px; display: flex; flex-direction: column; align-items: center; text-align: center;">
  <div class="sb-spinner-container mb-3" style="width: 56px; height: 56px; position: relative; display: flex; align-items: center; justify-content: center;">
    <div class="sb-spinner-ring"></div>
    <div class="sb-spinner-ring-inner"></div>
    <div class="sb-spinner-core" style="width: 30px; height: 30px;">
      <i class="fa fa-briefcase sb-spinner-icon" style="font-size: 13px;"></i>
    </div>
  </div>
  <h5 class="sb-loading-title" style="font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 4px;">Loading Projects</h5>
  <p class="sb-loading-subtitle" style="font-size: 13px; color: #64748b; margin-bottom: 14px;">Fetching manager projects, stage approvals, and team assignments...</p>
  <div class="sb-loading-progress-bar">
    <div class="sb-loading-progress-indeterminate"></div>
  </div>
</div>

<div *ngIf="!loading && matchedCustomerData.length === 0" class="empty-state">
  <i class="fa fa-inbox"></i>
  <p>No data found.</p>
</div>

<div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="table-card">
      <!-- Tab Content -->
      <div class="card-body">
        
        <!-- Pagination Controls -->
        <div class="pagination-controls">
          <!-- Left: Rows per page selector -->
          <div class="pagination-left">
            <div class="page-size-selector">
              <span class="pagination-label">Show</span>
              <select id="rowsPerPage" class="rows-per-page" [(ngModel)]="rowsPerPage" (change)="onPageSizeChange()">
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
              </select>
              <span class="pagination-label">entries</span>
            </div>
          </div>

          <!-- Right: Row Count Badge, Page Navigation & Jump -->
          <div class="pagination-right">
            <div class="row-count-badge">
              <i class="fa fa-list-ol" style="color: #0284c7; font-size: 11px;"></i>
              <span>Showing <strong>{{ getTotalCountForTab() > 0 ? getStartIndexForTab() : 0 }}</strong> - <strong>{{ getEndIndexForTab() }}</strong> of <strong>{{ getTotalCountForTab() }}</strong> rows</span>
            </div>

            <div class="pagination-nav">
              <button type="button" class="pagination-btn" (click)="firstPage()" [disabled]="currentPage === 1" title="First Page">
                <i class="fa fa-angle-double-left"></i>
              </button>
              <button type="button" class="pagination-btn" (click)="previousPage()" [disabled]="currentPage === 1" title="Previous Page">
                <i class="fa fa-chevron-left"></i>
              </button>

              <!-- Numbered Page Pills -->
              <div class="pagination-pages-list">
                <ng-container *ngFor="let p of getVisiblePages(); let i = index">
                  <button *ngIf="p !== '...'"
                          type="button"
                          class="pagination-num-btn"
                          [class.active]="p === currentPage"
                          (click)="goToPage(p)">
                    {{ p }}
                  </button>
                  <button *ngIf="p === '...'"
                          type="button"
                          class="pagination-num-btn pagination-ellipsis-btn"
                          (click)="jumpByPages(i === 1 ? -5 : 5)"
                          [title]="i === 1 ? 'Jump back 5 pages' : 'Jump forward 5 pages'">
                    &hellip;
                  </button>
                </ng-container>
              </div>

              <button type="button" class="pagination-btn" (click)="nextPage()" [disabled]="currentPage >= getTotalPagesForTab() || getTotalPagesForTab() === 0" title="Next Page">
                <i class="fa fa-chevron-right"></i>
              </button>
              <button type="button" class="pagination-btn" (click)="lastPage()" [disabled]="currentPage >= getTotalPagesForTab() || getTotalPagesForTab() === 0" title="Last Page">
                <i class="fa fa-angle-double-right"></i>
              </button>
            </div>

            <!-- Quick Page Jump -->
            <div class="pagination-jump" *ngIf="getTotalPagesForTab() > 1">
              <span class="jump-label">Go to</span>
              <input type="number"
                     class="jump-input"
                     [(ngModel)]="jumpPageInput"
                     (keyup.enter)="jumpToPage()"
                     min="1"
                     [max]="getTotalPagesForTab()"
                     placeholder="#" />
              <button type="button" class="jump-btn" (click)="jumpToPage()" title="Go to page">
                <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
          <div class="table-responsive gd_main_div_mobile">
            <table class="table table-striped custom-hover">
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>S.No</th>
                  <th>Project No</th>
                  <th>Customer Name</th>
                  <th>RFQ Date</th>
                  <th>Assigned To</th>
                  <th>Assigned Date</th>
                  <th>E.C.Date</th>
                  <th class="text-center">Target L.Time(W)</th>
                  <th class="text-center">Ageing</th>
                  <th>Progress</th>
                  <th>Approval Status</th>
                  <th>Status</th>
                  <!-- <th>Current Stage</th> -->
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let group of paginatedData; let i = index"
                  [ngClass]="{'highlighted-row': group?.project_id === highlightedProjectId}">
                  <td class="editIcon"
                    (click)="openProjectModel(projectModal, group.selectedVersionData, group.project_id)">
                    <i class="fa fa-pencil-alt circle-icon edit" aria-hidden="true" title="Edit Row Data"></i>
                  </td>
                  <!-- <td>{{ i+1 }}</td> -->
                  <td>{{ getStartIndexForTab() + i }}</td>

                  <td title="{{ group.projectName }}" (click)="onRowSelect(group)">
                    {{ group.projectName }}
                  </td>
                  <td title="{{ group.selectedVersionData?.customer_name }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.customer_name }}
                  </td>
                  <td class="td_date" title="{{ group.selectedVersionData?.rfqDate | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.rfqDate | date: 'dd-MM-yyyy' }}
                  </td>
                  <td title="{{ group.selectedVersionData?.assigned_to_name }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.assigned_to_name }}
                  </td>
                  <td class="td_date" title="{{ group.selectedVersionData?.assigned_date | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.assigned_date | date: 'dd-MM-yyyy' }}
                  </td>
                  <td class="td_date"
                    title="{{ group.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}
                  </td>
                  <td class="text-center" title="{{ group.selectedVersionData?.targetLeadTime }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.targetLeadTime }}
                  </td>

                
                  <td  class="text-center" (click)="onRowSelect(group)"


     [ngStyle]="{'color': (group.selectedVersionData?.status === 'Open' && isECDGreaterThanToday(group.selectedVersionData?.expectedCompletionDate)) ? 'red' : 'inherit'}"
    title="{{ calculateAgeing(group.selectedVersionData?.assigned_date, group.status, group.closed_date) }}">
  
  {{ calculateAgeing(group.selectedVersionData?.assigned_date, group.status, group.closed_date) }}
</td>


                  <td>
                    <div class="progress-container" (click)="onRowSelect(group)">
                      
                      <div
                        style="width: 100%; height: 14px; background-color: #f5f5f5; position: relative; border-radius: 10px; overflow: hidden;">

                        <!-- Progress text with color -->
                        <div
                          [style]="{
                            'position': 'absolute',
                            'z-index': '10',
                            'width': '100%',
                            'text-align': 'center',
                            'font-size': '12px',
                           
                            'margin-top': '-2px',
                            'font-weight': '600'
                          }"
                          *ngIf="group.selectedVersionData?.progress !== undefined && group.selectedVersionData?.progress !== null">
                          {{
                          group.selectedVersionData?.upload_status === 'New'
                          ? '0%'
                          : group.selectedVersionData?.progress
                          }}
                        </div>

                        <!-- Progress bar with color based on percentage -->
                        <div [ngStyle]="{
                          'width': group.selectedVersionData?.upload_status === 'New'
                            ? '0%'
                            : group.selectedVersionData?.progress,
                          'height': '100%',
                          'background-color': getProgressColor(group.selectedVersionData?.progress),
                          'border-radius': '10px'
                        }">
                        </div>

                      </div>



                      <span
                        *ngIf="group.selectedVersionData?.progress === undefined || group.selectedVersionData?.progress === null">
                        No Status
                      </span>
                    </div>
                  </td>

                  <td>
                    <button
                      type="button"
                      class="approval-status-btn"
                      [title]="getApprovalStatusLabel(group)"
                      (click)="openApprovalModal(approvalModal, group)">
                      {{ getApprovalStatusLabel(group) }}
                    </button>
                  </td>
               
                  <td title="{{ group.selectedVersionData?.status }}" (click)="onRowSelect(group)">
                    <span [ngStyle]="{
    'color': group.selectedVersionData?.status === 'Open' ? '#FFA500' : 
              group.selectedVersionData?.status === 'Closed' ? '#e23328' : 'inherit'
  }">
                      {{ group.selectedVersionData?.status }}
                    </span>
                  </td>

                 
                  <!-- <td title="{{ group.selectedVersionData?.currentstage }}" (click)="onRowSelect(group)">
                    <span [ngStyle]="{
    'color': group.selectedVersionData?.currentstage === 'Costing' ? '#1e90ff' :
              group.selectedVersionData?.currentstage === 'Procurement' ? '#ff4500' : 'inherit'
  }">
                      {{ group.selectedVersionData?.currentstage }}
                    </span>
                  </td> -->


                  <td>
                    <div class="d-flex align-items-center">
                      <!-- Costing Tab: Show version_id -->
                      <ng-container *ngIf="activeTab === 1">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.version_id"
                          (change)="onVersionChange($event, group)"
                          title="Version number">
                          <option *ngFor="let version_id of group.versions" [value]="version_id">
                            {{ version_id }}
                          </option>
                        </select>
                      </ng-container>

                      <!-- Procurement Tab: Show procurement versions -->
                      <ng-container *ngIf="activeTab === 2">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.procurement_version_id"
                          (change)="onProcurementVersionChange($event, group)"
                          title="Procurement Version number">
                          <option *ngFor="let procVersion of group.procurementVersions" [value]="procVersion">
                            {{ procVersion }}
                          </option>
                        </select>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="paginatedData.length === 0 && currentTabData.length === 0" class="tab-empty-state">
            <i class="fa fa-info-circle"></i>
            <span>No projects found in the {{ activeTab === 1 ? 'Costing' : 'Procurement' }} stage.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #customerModal let-modal>
  <div class="cust-modal-wrapper">
    <form [formGroup]="customerForm">

      <!-- Header -->
      <div class="cust-modal-header">
        <div class="cust-modal-header-left">
          <div class="cust-modal-icon">
            <i class="fa fa-user-plus"></i>
          </div>
          <div>
            <h5 class="cust-modal-title">Add Customer</h5>
            <p class="cust-modal-subtitle">Enter the new customer's details</p>
          </div>
        </div>
        <button type="button" class="cust-modal-close" (click)="closeCustomerModal()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="cust-modal-body">

        <!-- Row 1: Full Name + City -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="_customerFullName">
              <i class="fa fa-id-card proj-label-icon"></i> Customer Full Name
            </label>
            <input type="text" id="_customerFullName" class="proj-field-input"
              placeholder="Enter full name" formControlName="_customerFullName"
              (keyup)="onEnterCustomerName($event)" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('_customerFullName')?.touched && customerForm.get('_customerFullName')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Full Name is required (min 2 characters)
            </div>
            <div class="proj-field-error" *ngIf="isCustomerNameDuplicate">
              <i class="fa fa-exclamation-circle"></i> Customer already exists. Choose a different name.
            </div>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="city">
              <i class="fa fa-map-marker proj-label-icon"></i> City
            </label>
            <input type="text" id="city" class="proj-field-input"
              placeholder="Enter city" formControlName="city" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('city')?.touched && customerForm.get('city')?.invalid">
              <i class="fa fa-exclamation-circle"></i> City is required
            </div>
          </div>
        </div>

        <!-- Row 2: State + Country -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="state">
              <i class="fa fa-map proj-label-icon"></i> State
            </label>
            <input type="text" id="state" class="proj-field-input"
              placeholder="Enter state" formControlName="state" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('state')?.touched && customerForm.get('state')?.invalid">
              <i class="fa fa-exclamation-circle"></i> State is required
            </div>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="country">
              <i class="fa fa-globe proj-label-icon"></i> Country
            </label>
            <input type="text" id="country" class="proj-field-input"
              placeholder="Enter country" formControlName="country" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('country')?.touched && customerForm.get('country')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Country is required
            </div>
          </div>
        </div>

        <!-- Row 3: GST Number -->
        <div class="proj-form-grid cust-single-col">
          <div class="proj-form-field">
            <label class="proj-field-label" for="gstNumber">
              <i class="fa fa-file-text proj-label-icon"></i> GST Number
            </label>
            <input type="text" id="gstNumber" class="proj-field-input"
              placeholder="Enter 15-digit GST number" formControlName="gstNumber" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('gstNumber')?.touched && customerForm.get('gstNumber')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Enter a valid 15-digit GST Number
            </div>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="proj-modal-footer">
        <button type="button" class="proj-btn-secondary" title="Close" (click)="closeCustomerModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="button" class="proj-btn-primary" [disabled]="isCustomerNameDuplicate"
          title="Save customer" (click)="saveCustomer()">
          <i class="fa fa-check"></i> Save Customer
        </button>
      </div>

    </form>
  </div>
  </ng-template>


  <ng-template #projectModal let-modal>
  <div class="proj-modal-wrapper">
    <form [formGroup]="projectForm">

      <!-- Modal Header -->
      <div class="proj-modal-header">
        <div class="proj-modal-header-left">
          <div class="proj-modal-icon">
            <i class="fa fa-folder-open"></i>
          </div>
          <div>
            <h5 class="proj-modal-title">Add / Modify Project</h5>
            <p class="proj-modal-subtitle">Fill in the project details below</p>
          </div>
        </div>
        <button type="button" class="proj-modal-close" (click)="closeModal()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="proj-modal-body">

        <!-- Row 1: Project No + Customer Name -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="newProjectName">
              <i class="fa fa-hashtag proj-label-icon"></i> Project No
            </label>
            <input type="text" id="newProjectName" class="proj-field-input"
              formControlName="newProjectName" (keyup)="enterProject($event)"
              placeholder="Enter project number" />
            <div class="proj-field-error" *ngIf="isProjectNameDuplicate">
              <i class="fa fa-exclamation-circle"></i> Project already exists. Choose a different number.
            </div>
          </div>

          <div class="proj-form-field" style="position: relative;">
            <label class="proj-field-label">
              <i class="fa fa-building proj-label-icon"></i> Customer Name <span class="text-danger">*</span>
            </label>
            <div class="proj-customer-row">
              <ng-select class="proj-ng-select"
                [items]="allCustomerDetails"
                bindLabel="customerName"
                bindValue="customerName"
                [searchable]="true"
                [clearable]="true"
                [closeOnSelect]="true"
                [placeholder]="projectForm.get('customerFullName')?.value ? '' : 'Search or select customer...'"
                (search)="onCustomerSearch($event)"
                (change)="onAddNewCustomer($event)"
                (clear)="onCustomerClear()"
                formControlName="customerFullName">

                <!-- Template when an item is selected -->
                <ng-template ng-label-tmp let-item="item">
                  <div class="proj-selected-customer" [title]="item.customerName || item">
                    <i class="fa fa-building proj-customer-icon"></i>
                    <span class="proj-customer-text">{{ item.customerName || item }}</span>
                  </div>
                </ng-template>

                <!-- Template for dropdown options -->
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="proj-option-item">
                    <div class="proj-option-icon">
                      <i class="fa fa-building-o"></i>
                    </div>
                    <div class="proj-option-content">
                      <span class="proj-option-title">{{ item.customerName }}</span>
                      <span class="proj-option-sub" *ngIf="item.customer_id || item.id">ID: #{{ item.customer_id || item.id }}</span>
                    </div>
                    <span class="proj-option-badge" *ngIf="projectForm.get('customerFullName')?.value === item.customerName">
                      <i class="fa fa-check"></i>
                    </span>
                  </div>
                </ng-template>

                <!-- Template when no option matches -->
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="proj-not-found-box">
                    <div class="proj-not-found-text">
                      <i class="fa fa-search"></i>
                      <span>No customer found matching "<strong>{{ searchTerm }}</strong>"</span>
                    </div>
                    <button type="button" class="proj-create-inline-btn"
                      (click)="openCustomerModel(customerModal, searchTerm)">
                      <i class="fa fa-user-plus"></i> Create Customer "{{ searchTerm }}"
                    </button>
                  </div>
                </ng-template>
              </ng-select>

              <button class="proj-add-customer-btn" [class.proj-add-pulse]="showAddButton"
                (click)="openCustomerModel(customerModal)"
                [title]="showAddButton ? 'Add customer: ' + searchText : 'Create new customer'"
                type="button">
                <i class="fa fa-user-plus"></i>
              </button>
            </div>
            <div class="proj-field-error"
              *ngIf="projectForm.get('customerFullName')?.touched && projectForm.get('customerFullName')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Customer Name is required
            </div>
          </div>
        </div>

        <!-- Row 2: RFQ Date + Expected Completion Date -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="rfqDate">
              <i class="fa fa-calendar proj-label-icon"></i> RFQ Date
            </label>
            <input type="date" id="rfqDate" class="proj-field-input"
              formControlName="rfqDate" [max]='maxToday' (change)="updateRfqDate()" />
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="completionDate">
              <i class="fa fa-calendar-check-o proj-label-icon"></i> Expected Completion Date
            </label>
            <input type="date" id="completionDate" class="proj-field-input"
              formControlName="completionDate" [min]="nextMaxDate"
              [disabled]="isExpectedCompletionDateDisabled" (change)="updatecompletionDate()" />
          </div>
        </div>

        <!-- Row 3: Target Lead Time + Assign To -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label">
              <i class="fa fa-clock-o proj-label-icon"></i> Target Lead Time (Weeks)
            </label>
            <input type="number" class="proj-field-input"
              formControlName="targetLT" placeholder="Enter number of weeks" />
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="assignTo">
              <i class="fa fa-user proj-label-icon"></i> Assign To
            </label>
            <select id="assignTo" name="assignTo" class="proj-field-select"
              formControlName="assignTo" required>
              <option [ngValue]="null" disabled selected>Select engineer</option>
              <option *ngFor="let user of engineersData" [value]="user.engineer_id">{{ user.engineer_name }}</option>
            </select>
          </div>
        </div>

        <!-- Row 4: Current Stage + Version -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="currentStage">
              <i class="fa fa-tasks proj-label-icon"></i> Current Stage
            </label>
            <select id="currentStage" name="currentStage" class="proj-field-select"
              formControlName="currentStage" required>
              <option disabled selected [ngValue]="null">Select Stage</option>
              <option value="Costing">Costing</option>
              <option value="Procurement">Procurement</option>
            </select>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label">
              <i class="fa fa-code-fork proj-label-icon"></i> Version
            </label>
            <input type="number" class="proj-field-input"
              formControlName="version_id" placeholder="e.g. 1" />
          </div>
        </div>

        <!-- Landing Cost -->
        <div class="proj-landing-row">
          <button type="button" class="proj-landing-btn" title="Configure landing cost"
            (click)="onLandinCost(landinCostModal)">
            <i class="fa fa-calculator"></i> Landing Cost
          </button>
        </div>

      </div>

      <!-- Modal Footer -->
      <div class="proj-modal-footer">
        <button type="button" class="proj-btn-secondary" title="Close" (click)="closeModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="submit" class="proj-btn-primary"
          [disabled]="isProjectNameDuplicate" (click)="save()" title="Save project">
          <i class="fa fa-check"></i> Save Project
        </button>
      </div>

    </form>
  </div>
</ng-template>

  <ng-template #landinCostModal let-modal>
  <div class="lc-modal-wrapper">

    <!-- Header -->
    <div class="lc-modal-header">
      <div class="lc-modal-header-left">
        <div class="lc-modal-icon">
          <i class="fa fa-calculator"></i>
        </div>
        <div>
          <h5 class="lc-modal-title">Landing Cost</h5>
          <p class="lc-modal-subtitle">Configure landing cost for this project</p>
        </div>
      </div>
      <button type="button" class="lc-modal-close" (click)="closeLandingCost(modal)" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="lc-modal-body">

      <!-- Q1 -->
      <div class="lc-question-card">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q1</span>
          <span class="lc-question-text">Do you want to calculate Landing Cost for this project?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q1 === true">
            <input type="radio" name="q1" [checked]="onQn123?.q1 === true" (click)="onQn1Change('yes')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q1 === false">
            <input type="radio" name="q1" [checked]="onQn123?.q1 === false" (click)="onQn1Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Q2 -->
      <div class="lc-question-card" *ngIf="showQn2">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q2</span>
          <span class="lc-question-text">Do you want to consider Duties for calculating landing cost?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q2 === true">
            <input type="radio" name="q2" [checked]="onQn123?.q2 === true" (click)="onQn2Change('yes')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q2 === false">
            <input type="radio" name="q2" [checked]="onQn123?.q2 === false" (click)="onQn2Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Q3 -->
      <div class="lc-question-card" *ngIf="showQn3">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q3</span>
          <span class="lc-question-text">Do you want to adjust duty value?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q3 === true">
            <input type="radio" name="q3" [checked]="onQn123?.q3 === true" (click)="onQn3Change('export')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q3 === false">
            <input type="radio" name="q3" [checked]="onQn123?.q3 === false" (click)="onQn3Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
        <div class="lc-duty-input-row" *ngIf="showDutyInput">
          <label class="lc-duty-label"><i class="fa fa-percent"></i> Generic Duty Percentage</label>
          <input type="number" class="lc-duty-input" placeholder="e.g. 18"
                 [(ngModel)]="dutyValuePercentage" />
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="lc-modal-footer">
      <button type="button" class="proj-btn-secondary" title="Close" (click)="closeLandingCost(modal)">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="button" class="proj-btn-primary" title="Save" (click)="saveLandingCost(modal)">
        <i class="fa fa-check"></i> Save
      </button>
    </div>

  </div>
</ng-template>

<ng-template #approvalModal let-modal>
  <div class="approval-modal-wrapper">
    <div class="approval-modal-header">
      <div class="approval-modal-header-content">
        <div class="approval-status-pill">
          <i class="fa fa-check-circle-o"></i>
          {{ selectedApprovalProject?.selectedVersionData?.approval_status || 'Pending' }}
        </div>
        <h5 class="approval-modal-title">
          Review Project Approval
        </h5>
        <p class="approval-modal-subtitle">
          {{ selectedApprovalProject?.selectedVersionData?.projectName || selectedApprovalProject?.projectName }}
        </p>
      </div>
      <button type="button" class="approval-modal-close" (click)="closeApprovalModal()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="approval-modal-body">
      <div class="approval-summary-grid">
        <div class="approval-modal-detail">
          <span>Project ID</span>
          <strong>{{ selectedApprovalProject?.selectedVersionData?.project_id || selectedApprovalProject?.project_id }}</strong>
        </div>
        <div class="approval-modal-detail">
          <span>Version</span>
          <strong>{{ selectedApprovalProject?.selectedVersionData?.version_id }}</strong>
        </div>
        <div class="approval-modal-detail">
          <span>Procurement Version</span>
          <strong>{{ selectedApprovalProject?.selectedVersionData?.procurement_version_id || 0 }}</strong>
        </div>
        <div class="approval-modal-detail">
          <span>Assigned To</span>
          <strong>{{ selectedApprovalProject?.selectedVersionData?.assigned_to_name || 'NA' }}</strong>
        </div>
      </div>

      <!-- Approval Status Dropdown Selection -->
      <div style="margin-top: 16px; margin-bottom: 16px;">
        <label for="approvalStatusDropdown" style="font-weight: 600; color: #475569; margin-bottom: 8px; display: block;">Approval Status</label>
        <select
          id="approvalStatusDropdown"
          class="form-control"
          style="border-radius: 6px; border: 1px solid #cbd5e1; padding: 8px; width: 100%;"
          [(ngModel)]="selectedApprovalStatus">
          <option value="Approved">Approved</option>
          <option value="Rework Required">Rework Required</option>
          <option value="Rejected">Rejected</option>
        </select>
      </div>

      <!-- Dynamic Comments Box -->
      <div class="approval-comment-box" *ngIf="selectedApprovalStatus === 'Rework Required' || selectedApprovalStatus === 'Rejected'">
        <label for="approvalReviewComments" class="approval-comment-label">
          {{ selectedApprovalStatus === 'Rework Required' ? 'Rework Comments' : 'Rejection Comments' }}
        </label>
        <textarea
          id="approvalReviewComments"
          class="approval-comment-textarea"
          rows="4"
          [(ngModel)]="approvalReviewComments"
          [placeholder]="selectedApprovalStatus === 'Rework Required' ? 'Tell the engineer what needs to be corrected' : 'Explain the reason for rejection'"></textarea>
        <div class="approval-comment-hint">
          Add clear review notes so the next revision is easier to complete.
        </div>
      </div>
    </div>

    <!-- Combined dynamic action footer -->
    <div class="approval-modal-footer">
      <button
        type="button"
        class="approval-btn approval-btn-secondary"
        [disabled]="isApprovalSubmitting"
        (click)="closeApprovalModal()">
        <i class="fa fa-times"></i>
        Cancel
      </button>
      <button
        type="button"
        class="approval-btn"
        [disabled]="isApprovalSubmitting"
        [ngStyle]="{
          'background-color': selectedApprovalStatus === 'Approved' ? '#dcfce7' : (selectedApprovalStatus === 'Rework Required' ? '#fef3c7' : '#fee2e2'),
          'color': selectedApprovalStatus === 'Approved' ? '#15803d' : (selectedApprovalStatus === 'Rework Required' ? '#b45309' : '#b91c1c'),
          'border-color': selectedApprovalStatus === 'Approved' ? '#bbf7d0' : (selectedApprovalStatus === 'Rework Required' ? '#fde68a' : '#fecaca')
        }"
        style="padding: 8px 16px; border: 1px solid; border-radius: 6px; margin-left: 8px; font-weight: 600;"
        (click)="submitApprovalManager()">
        <i class="fa fa-check-circle"></i>
        Submit
      </button>
    </div>
  </div>
</ng-template>


<!-- Modern Loading Overlay for Project Refresh -->
<div *ngIf="isRefresh" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-refresh sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">Refreshing Manager Dashboard</h4>
      <p class="sb-loading-subtitle">Fetching latest project records, approval stages, and version metrics...</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>
